export enum LoanOriginationSystemIntermediariesFiltersActionTypes {
  SetSearchInputValue = 'loanOriginationSystemIntermediariesFilters/setSearchInputValue',
  ToggleFiltersPopup = 'loanOriginationSystemIntermediariesFilters/toggleFiltersPopup',
  ChangePopupFilters = 'loanOriginationSystemIntermediariesFilters/changePopupFilters',
  FilterIntermediariesByMembers = 'loanOriginationSystemIntermediariesFilters/filterIntermediariesByMembers',
  ResetAllFilters = 'loanOriginationSystemIntermediariesFilters/resetAllFilters',
}
